<template>
  <div class="navbar-new-section cashier">
    <b-navbar toggleable="lg" :sticky="true">
      <!-- <b-navbar-brand href="#">NavBar</!-->

      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <div @click="$router.replace('/cashier')" class="cursor-pointer">
            <b-img
              :src="require('@/assets/logo-dashboard.svg')"
              fluid
              alt="Fluid image"
            ></b-img>
          </div>

          <!-- <div class="form-input-search">
            <b-form-input
              size="sm"
              class="mr-sm-2"
              placeholder="Search"
            ></b-form-input>
          </div> -->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <!-- <b-form-input
              size="sm"
              class="mr-sm-2"
              placeholder="Search"
            ></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit"
              >Search</b-button
            > -->
          </b-nav-form>

          <b-nav-item-dropdown right class="m__r--40">
            <template v-slot:button-content>
              <i class="far fa-bell f--25 p__t--8"></i>
            </template>
            <b-dropdown-item href="#">No data</b-dropdown-item>
            <!-- <b-dropdown-item href="#">ES</b-dropdown-item>
            <b-dropdown-item href="#">RU</b-dropdown-item>
            <b-dropdown-item href="#">FA</b-dropdown-item> -->
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <b-img
                :src="require('@/assets/logo-user.png')"
                rounded="circle"
                height="40"
                alt="Circle image"
              ></b-img>
            </template>
            <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
            <b-dropdown-item to="/logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      items: []
    };
  }
};
</script>

<style lang="scss">
.navbar-new-section.cashier {
  background: linear-gradient(180deg, #1d2d4e 0%, #15213c 100%);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);
  padding-top: 0px;
  padding-bottom: 0px;
  .form-input-search {
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    color: #8c8f97 !important;
    &::before {
      position: absolute;
      top: 23px;
      left: 37px;
      content: '\F002';
    }
  }
  .dropdown-toggle::after {
    border-top: unset;
  }
  .far.fa-bell {
    color: #fff;
  }
  input {
    background: #fcfcfc;
    border: 1px solid #f2f0f0;
    box-sizing: border-box;
    border-radius: 200px;
    width: 345px;
    height: 39px;
    padding-left: 50px;
    &:focus {
      border-color: unset;
      box-shadow: unset;
    }
    &::placeholder {
      font-family: 'Source Sans Pro';
      color: #8c8f97 !important;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 37px;
    }
  }
}
</style>
